<template>
	<div class="parameter" :class="urgencyClass(value.urgency_type)">
		<div class="bullet"></div>
		<div class="name">{{ value.name }}</div>
		<div class="min">{{ min }} <span v-html="units"></span></div>
		<div class="max">{{ max }} <span v-html="units"></span></div>
		<div class="btn-group">
			<button-icon-loading @click.native="$emit('edit')" icon="edit"/>
			<button-icon-loading @click.native="deleteParameter(value.id)" :loading="loading" icon="trash" class="btn-delete"/>
		</div>
	</div>
</template>

<script>
export default {
	props: [
		'user_uid',
		'watch_id',
		'type_id',
		'value',
		'deleteParameter',
		'loading',
		'units'
	],
	computed: {
		min () {
			switch (parseInt(this.type_id)) {
				case 2:
					return `${this.value.interval_min_start} ${this.value.interval_min_end}`
				default:
					return this.value.min
			}
		},
		max () {
			switch (parseInt(this.type_id)) {
				case 2:
					return `${this.value.interval_max_start} ${this.value.interval_max_end}`
				default:
					return this.value.max
			}
		}
	},
	methods: {
		urgencyClass (value) {
			switch (parseInt(value)) {
				case 1:
					return 'urgency-min'
				case 2:
					return 'urgency-med'
				case 3:
					return 'urgency-max'
				default:
					return ''
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/readings/shared/widgets/rows/ReadingsWidgetAlertParametersRow.vue